<template>
  <div class="whatsapp-consumptions-reports-container">
    <VirtualAssistantEventsFilters
      ref="filters"
      :events="filteredVirtualAssistantConsumptions"
      @filter-change="onFilterChange"
    />
    <div class="reports-wrap">
      <VirtualAssistantEventsSummary
        :events="filteredVirtualAssistantConsumptions"
      />
      <div class="bar-section full-width">
        <VirtualAssistantEventsCategoryChart
          :events="filteredVirtualAssistantConsumptions"
        />
      </div>
      <div class="table-section no-bg">
        <h5 class="chart-title">
          {{ $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.CHART.BY_CATEGORY') }}
        </h5>
        <VirtualAssistantEventsReasonsTable
          :events="filteredVirtualAssistantConsumptions"
        />
      </div>
      <div class="table-section no-bg">
        <h5 class="chart-title">
          {{ $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.CHART.BY_DETAIL') }}
        </h5>
        <VirtualAssistantEventsDetailsTable
          :events="filteredVirtualAssistantConsumptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VirtualAssistantEventsDetailsTable from './components/VirtualAssistantEventsDetailsTable';
import VirtualAssistantEventsReasonsTable from './components/VirtualAssistantEventsReasonsTable';
import VirtualAssistantEventsFilters from './components/VirtualAssistantEventsFilters';
import VirtualAssistantConsumptionsApi from '../../../../api/inbox/historyVirtualAssistantConsumptions';
import VirtualAssistantEventsCategoryChart from './components/VirtualAssistantEventsCategoryChart';
import VirtualAssistantEventsSummary from './components/VirtualAssistantEventsSummary';

export default {
  name: 'VirtualAssistantConsumptionsReportsView',
  components: {
    VirtualAssistantEventsFilters,
    VirtualAssistantEventsReasonsTable,
    VirtualAssistantEventsDetailsTable,
    VirtualAssistantEventsCategoryChart,
    VirtualAssistantEventsSummary,
  },
  data() {
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);

    return {
      VirtualAssistantConsumptions: [],
      filters: {
        customDateRange: [sevenDaysAgo, today],
        inboxes: [],
      },
    };
  },
  computed: {
    filteredVirtualAssistantConsumptions() {
      const { customDateRange = [], inboxes = [] } = this.filters;
      const [start, end] = customDateRange;

      return this.VirtualAssistantConsumptions.filter(item => {
        const createdDate = new Date(item.started_at);
        const createdDateOnly = new Date(
          createdDate.getFullYear(),
          createdDate.getMonth(),
          createdDate.getDate()
        );

        const startDate = start ? new Date(start) : null;
        const endDate = end ? new Date(end) : null;

        const dateMatch =
          !startDate ||
          !endDate ||
          (createdDateOnly >= startDate && createdDateOnly <= endDate);

        const inboxMatch = !inboxes.length || inboxes.includes(item.inbox_name);

        return dateMatch && inboxMatch;
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.filters.emitFilters();
    });
  },
  methods: {
    prepareVirtualAssistantConsumptions(rawMessages) {
      if (!Array.isArray(rawMessages)) return [];

      return rawMessages.map(msg => {
        const baseUrl = window.location.origin;

        let link_conversation = msg.conversation_link || '';

        if (link_conversation && link_conversation.startsWith('/')) {
          link_conversation = `${baseUrl}${link_conversation}`;
        }

        return {
          ...msg,
          link_conversation,
        };
      });
    },
    async onFilterChange(newFilters) {
      this.filters = {
        ...this.filters,
        ...newFilters,
      };

      try {
        const [start, end] = this.filters.customDateRange || [];
        const formatDate = date => new Date(date).toISOString().split('T')[0];

        const response = await VirtualAssistantConsumptionsApi.getAll({
          startDate: start ? formatDate(start) : null,
          endDate: end ? formatDate(end) : null,
        });

        const messages = Array.isArray(response.data)
          ? response.data
          : response.data?.data || [];

        this.VirtualAssistantConsumptions =
          this.prepareVirtualAssistantConsumptions(messages);
      } catch (error) {
        console.error(
          this.$t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.ERRORS.FETCH'),
          error
        );

        this.VirtualAssistantConsumptions = [];
      }
    },
  },
};
</script>

<style scoped>
.whatsapp-consumptions-reports-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  align-items: flex-start;
}

.whatsapp-consumptions-reports-container > *:first-child {
  width: 280px;
  flex-shrink: 0;
  margin-right: 24px;
}

.reports-wrap {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  padding: 2vh 2vw 10vh;
  background: #f8fafc;
  overflow: hidden;
  min-width: 0;
  box-sizing: border-box;
}

.bar-section,
.table-section {
  margin-top: 4vh;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  width: 100%;
  overflow-x: auto;
}

.table-section.no-bg {
  background: transparent;
  padding: 0;
  box-shadow: none;
}

.chart-block {
  flex: 1 1 30%;
  min-width: 280px;
  height: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
  background: transparent;
  border-radius: 0;
  box-shadow: none;
}

.chart-block canvas {
  width: 100% !important;
  height: 100% !important;
  max-width: 300px;
  max-height: 300px;
}

.bar-section-group {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 1rem;
  flex-wrap: nowrap;
}

.chart-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 12px;
}

.bar-section.full-width {
  flex: 1 1 100%;
  margin-top: 2vh;
}

.bar-section.wide {
  flex: 1 1 70%;
  max-height: 500px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.bar-section.narrow {
  flex: 1 1 28%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.whatsapp-api-info {
  margin-top: 18px;
  background-color: #e0e0e0;
  color: #222;
  padding: 18px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.8;
  text-align: center;
}

.whatsapp-api-info a {
  color: #4fc3f7;
  text-decoration: underline;
  word-break: break-word;
}
</style>
